module.exports = __webpack_public_path__ + "media/images/Logo-APP-f60a248ed0bfb78219e4d3a949aa9aeb.png";